export default [
  {
    leistungstext: "Gesetzliche Haftpflicht des Versicherungsnehmers als Bauherr",
    infoText:
      "Die gesetzliche Haftpflicht des Versicherungsnehmers als Bauherr für das im Versicherungsvertrag benannte Bauvorhaben.",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Gesetzliche Haftpflicht als Besitzer für das zu bebauende Grundstück",
    infoText:
      "Die gesetzliche Haftpflicht des Versicherungsnehmers für das bebauende Grundstück und das zu errichtende Bauwerk.",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Abwehr unberechtigter Ansprüche",
    infoText:
      "Die Prüfung der Haftpflichtfrage, die Abwehr unberechtigter Schadenersatzansprüche und die Freistellung des Versicherungsnehmers von berechtigten Ansprüchen.",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Personen-, Sach- und Vermögensschäden",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Regressansprüche der Berufsgenossenschaft",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Unfälle durch schlecht aufgestellte Bauzäune",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Streu- und Räumpflicht",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Abbruch-, Einreiß- und Rammarbeiten",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Bauen in Eigenleistung",
    infoText: "",
    leistungen: ["Bis 25.000 € beitragsfrei"],
  },
];
